@if (url()) {
  <app-metrics [metrics]="kpis()" />
  <iframe
    i18n-aria-label
    aria-label="Slurry preview"
    #myIframe
    [src]="safeUrl()"
    (load)="handleLoad(myIframe)"
    [ngStyle]="{ opacity: isLoaded() ? 1 : 0 }"
  ></iframe>
  @if (treatments().length) {
    <div class="kpi-card flex-grow">
      <div class="title" i18n>Application</div>
      <div class="treatment">
        <table>
          <tr>
            <th class="left" colspan="2" i18n>Tank number</th>
            <th i18n>Application rate</th>
            <th i18n>Adjustment</th>
            <th i18n>Tank usage</th>
          </tr>

          @for (treatment of treatments(); track treatment.id) {
            <tr>
              <td class="color"><div [ngStyle]="{ borderLeftColor: treatment.color }"></div></td>
              <td class="left">{{ treatment.tank }}</td>
              <td>{{ treatment.rate }}</td>
              <td>{{ treatment.adjustment }}</td>
              <td>{{ treatment.usage }}</td>
            </tr>
          }
        </table>
      </div>
    </div>
  }
} @else {
  <div class="placeholder">
    <app-icon icon="map" />
    <div i18n>Please select a configuration above</div>
  </div>
}
